import React from 'react';

import { WidgetDropdownCategory } from 'widgets/WidgetCategory';
import { WidgetDropdownItem } from 'widgets/WidgetsService';
import { AvailableWidgetsGroup } from 'appToolbar/AddWidgetModal/AvailableWidgetsGroup';
import { AddWidgetSelectedItem } from 'appToolbar/AddWidgetModal/AddWidgetModal';
import { WidgetType } from 'widgets/WidgetType';

export interface AvailableWidgetsAccordianProps {
    addMultiple: boolean;
    data: Array<{
        category: WidgetDropdownCategory;
        options: WidgetDropdownItem[];
    }>;
    searchText: string;
    previewItem?: AddWidgetSelectedItem;
    selectedItems: AddWidgetSelectedItem[];
    onClickAddItem: (wt: WidgetType) => void;
    onClickItem: (wt: AddWidgetSelectedItem) => void;
}

export function AvailableWidgetsAccordian(
    props: AvailableWidgetsAccordianProps
) {
    const {
        data,
        searchText,
        previewItem,
        selectedItems,
        onClickAddItem,
        onClickItem,
        addMultiple,
    } = props;

    return (
        <div className="AvailableWidgetsAccordian">
            {data.map((g) => (
                <AvailableWidgetsGroup
                    addMultiple={addMultiple}
                    key={g.category.category}
                    group={g}
                    previewItem={previewItem}
                    searchText={searchText}
                    selectedItems={selectedItems}
                    onClickItem={onClickItem}
                    onClickAddItem={onClickAddItem}
                />
            ))}
        </div>
    );
}
